import React, { useContext } from "react";
import { ActiveThemeContext } from "../themeCache";
import { DEFAULT_TEMPLATE, PAGE_TEMPLATES } from "./registry";
import ProductDetails from "../../components/frontend/collections/ProductDetails";
import Cart from "../../components/frontend/Cart";
import Checkout from "../../components/frontend/Checkout";

// Template value -> component, per page. Every template gets the same route
// props and uses the shared hooks in src/hooks for data and money.
const COMPONENTS = {
  product: { classic: ProductDetails },
  cart: { classic: Cart },
  checkout: { classic: Checkout },
};

/**
 * A route component that renders the template the published theme chose for
 * this page, or the classic one when the choice is missing or unknown.
 */
export function themedPage(page) {
  const { settingKey } = PAGE_TEMPLATES[page];
  function ThemedPage(props) {
    const active = useContext(ActiveThemeContext);
    const choice = active?.theme?.settings?.[settingKey];
    const Template = COMPONENTS[page][choice] || COMPONENTS[page][DEFAULT_TEMPLATE];
    return <Template {...props} />;
  }
  ThemedPage.displayName = `Themed(${page})`;
  return ThemedPage;
}
